"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.mkUserAction = function (action) {
  return action;
};

exports.createPlugin = function (name) {
  var prodoInternals = {
    name: name
  };
  return {
    name: name,
    init: function init(initFn) {
      prodoInternals.init = initFn;
    },
    prepareActionCtx: function prepareActionCtx(actionCtxFn) {
      prodoInternals.actionCtx = actionCtxFn;
    },
    prepareViewCtx: function prepareViewCtx(viewCtxFn) {
      prodoInternals.viewCtx = viewCtxFn;
    },
    onCompleteEvent: function onCompleteEvent(onCompleteEventFn) {
      prodoInternals.onCompleteEvent = onCompleteEventFn;
    },
    action: function action(func, actionName) {
      func.__name = actionName;
      func.__pluginName = name;
      return func;
    },
    setProvider: function setProvider(provider) {
      prodoInternals.Provider = provider;
    },
    exposeUniverseVars: function exposeUniverseVars(_exposeUniverseVars) {
      prodoInternals.exposedUniverseVars = _exposeUniverseVars;
    },
    _internals: prodoInternals
  };
};